import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ffeee7fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "video-container is-flex is-justify-content-center is-align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "is-flex is-flex-direction-column is-align-items-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "loading-logo",
  src: "https://i.imgur.com/BvpCaxv.png",
  alt: "wisevet_live_logo"
}, null, -1))
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spinner fa-spin fa-4x" }, null, -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 1,
  class: "main-div"
}
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "columns mt-4" }
const _hoisted_11 = { class: "column is-one-third-desktop is-offset-one-third-desktop" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://i.imgur.com/uA3fRLZ.png",
  class: "image",
  alt: "logo"
}, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "message is-warning"
}
const _hoisted_14 = { class: "message-header" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle" }, null, -1))
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "field" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "has-text-grey-light is-size-7" }
const _hoisted_20 = { class: "is-flex is-justify-content-space-between is-align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JitsiIframe = _resolveComponent("JitsiIframe")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.meetingHash)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isChecking)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('message.connecting')), 1),
                _hoisted_6
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_JitsiIframe, {
                  "meeting-hash": _ctx.meetingHash,
                  "user-data": _ctx.userData
                }, null, 8, ["meeting-hash", "user-data"])
              ]))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              (_ctx.showWarning)
                ? (_openBlock(), _createElementBlock("article", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", null, [
                        _hoisted_15,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.meetingUnavailable')), 1)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "message-body",
                      innerHTML: _ctx.$t('message.meetingUnavailableDetails')
                    }, null, 8, _hoisted_16)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("form", {
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.checkPIN && _ctx.checkPIN(...args)), ["prevent"])),
                class: "p-3"
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('message.meetingPIN')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "input has-text-centered is-size-2",
                    placeholder: "xxxxxx",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pin) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.pin]
                  ]),
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('message.insertPINReceivedEmail')), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('message.goBack')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("button", {
                    class: _normalizeClass(["button is-primary", {'is-loading':_ctx.isCheckingPIN}])
                  }, _toDisplayString(_ctx.$t('message.connect')), 3)
                ])
              ], 32)
            ])
          ])
        ])
      ]))
}